import {CommonModule} from "@angular/common";
import {Component, OnInit} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  NavController,
  NavParams,
  ModalController,
  ToastController,
  IonicModule,
} from "@ionic/angular";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {MdaProvider} from "src/app/services/mda/mda";

@Component({
  selector: "app-mda-encontro-desmarcar",
  templateUrl: "./mda-encontro-desmarcar.page.html",
  styleUrls: ["./mda-encontro-desmarcar.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, TranslateModule],
})
export class MdaEncontroDesmarcarPage implements OnInit {
  mda: any = {};
  desmarcadoPor: string = "";
  validations_form: FormGroup;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public mdaProvider: MdaProvider,
    public toastCtrl: ToastController,
    private translate: TranslateService
  ) {
    this.mda = this.navParams.get("mda");
    this.desmarcadoPor = this.navParams.get("desmarcadoPor");
    this.validations_form = this.formBuilder.group({
      comentarioDesmarcado: new FormControl(
        this.mda.comentarioDesmarcado,
        Validators.compose([
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(150),
          Validators.pattern(/^(?!\s*$).+/),
        ])
      ),
    });
  }

  ngOnInit() {}

  validation_messages = {
    comentarioDesmarcado: [
      {type: "required", message: this.translate.instant("Necessário informar o motivo")},
      {type: "minlength_or_pattern", message: this.translate.instant("O motivo deve conter no mínimo 10 caracteres.")},
      {type: "maxlength", message: this.translate.instant("O motivo deve conter no máximo 150 caracteres.")},
    ],
  };

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  onSubmit(mda: {comentarioDesmarcado: any}) {
    this.mda.comentarioDesmarcado = mda.comentarioDesmarcado;
    this.mdaProvider
      .desmarcar(this.mda.id, this.mda.idMda, mda.comentarioDesmarcado, this.desmarcadoPor)
      .subscribe(async () => {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant("Encontro desmarcado com sucesso!"),
          duration: 3000,
        });

        toast.present();
        
        await this.modalCtrl.dismiss(true);
        setTimeout(async () => {
         await this.modalCtrl.dismiss(true);
        }, 100);
      });
  }
}
